/**
 * CaseManageSlice Clinical Review Reducers
 * 
 * Reducers for managing clinical review details on cases.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { ClinicalReviewView } from '../../types/caseManageTypes';
import { CaseManageSliceState } from '../state';

// =============================================================================
// CLINICAL REVIEW REDUCERS
// =============================================================================

/**
 * Update clinical review details
 */
export const updateClinicalReviewDetails: CaseReducer<
  CaseManageSliceState,
  PayloadAction<Partial<ClinicalReviewView>>
> = (state, action) => {
  if (state.currentCase) {
    state.currentCase.clinicalReview = {
      ...state.currentCase.clinicalReview,
      ...action.payload,
    };
    state.isEdited = true;
    if (!state.editedFields.includes('clinicalReview')) {
      state.editedFields.push('clinicalReview');
    }
  }
};
